import React, { useState, useEffect, useContext, useRef } from 'react';

// import useSound from 'use-sound';
// import se_07_scan from '../sound/s07_scan.mp3';
// import se_08 from '../sound/s08_se_delay0.mp3';


import { zxingQRScan } from '../components/ZxingQRScanUtil';
import { SharedInfoContext } from '../components/SharedInfoContextProvider';
import { useUserAPI } from '../components/useUserAPI';
import { iAeonGetPayBarCode } from '../library/iaeon_sdk.js';
import { iAeonGetPointBarCode } from '../library/iaeon_sdk.js';
import { iAeonGetMemberInfo } from '../library/iaeon_sdk.js';
import { useSDK } from "../scandit/sdk";

// PayModal はお会計〜QRScanner遷移までのバックグラウンド処理のみを担い、
// モーダルUIは表示しない（お会計ボタン押下で直接QRScanner画面へ遷移する仕様のため）
export const PayModal = (props) => {

const { loaded, sdk } = useSDK();

// const [se07_scan] = useSound(se_07_scan);
// const [se08_se] = useSound(se_08);


// const { otbCode, updateOtbCode } = useContext(SharedInfoContext);
const sharedInfo = useContext(SharedInfoContext);
const { terminalCode, updateTerminalCode } = useContext(SharedInfoContext);
//AeonPay連携 0:未許可 1:許可
const { aeonPayFlg, updateAeonPayFlg } = useContext(SharedInfoContext);
//AEON Pay連携バージョン確認：5.1.0より小さい 連携なし（暫定版）、5.1.0以上 連携可能（連携版）
const { aeonPayVerCheck, updateAeonPayVerCheck } = useContext(SharedInfoContext);


//----------------------------------------
//お支払いへ進む
//----------------------------------------

useEffect(() => {
	console.log("props.isButtonDisabled: "+props.isButtonDisabled);
}, [props.isButtonDisabled]);

//ログアップロードAPI
const { loguploadAPI, data: loguploadData, loading: loguploadLoading, error: loguploadError } = useUserAPI();

//お支払いボタン
function moveQR() {
	console.log("props.isButtonDisabled: "+props.isButtonDisabled);
	if (props.isButtonDisabled === true){
		console.log("siharai_btn:skip");
		return; // すでにボタンが無効化されていたら処理をスキップ
	}else {
		// ボタンをクリックしたので即座に無効化
		props.setIsButtonDisabled(true);

		props.setSoundState("se08_se");
		// console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"siharai_btn:click");

		// 少し遅延を入れてからQRスキャンに遷移（連打防止のため）
		setTimeout(() => {
			goQRScan();
		}, 100);
	}
}

// お会計ボタン押下（props.showPayModal = true）を検知したら、
// 「お支払いへ進む」ボタン押下時と同じ処理を自動的に開始する（モーダルUIは表示しないため）
useEffect(() => {
	if (props.showPayModal === true) {
		moveQR();
	}
}, [props.showPayModal]);

//ログアップロードAPI レスポンス
useEffect(() => {
	if(loguploadData){
		console.log(loguploadData);
		if (loguploadData.isSuccess == true) { //SUCCESS
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
		}else{ //ERROR
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
			console.log(`【loguploadAPI】 errorCode: ${loguploadData.errorCode}`);
			console.log(`【loguploadAPI】 errorMessage: ${loguploadData.errorMessage}`);
		}
	}
}, [loguploadData]);


//----------------------------------------
//お支払いモーダル表示時に、会員情報取得
//----------------------------------------

//2.会員情報取得API
// function callAPI_2(tcode){
//     let successCall_2 = function(success){
// 		// alert("【iAeonGetMemberInfo】success");
//         // var aaa = JSON.stringify(success);
// 		console.log("----------------------------");
// 		console.log("【iAeonGetMemberInfo】");
//         var aaa = success;
// 		console.log('【iAeonGetMemberInfo】success：' + aaa);
// 		console.log('【iAeonGetMemberInfo】aeon_memberid：' + aaa.aeon_memberid);
// 		// console.log('【iAeonGetMemberInfo】favorite_store：' + aaa.favorite_store);
// 		// console.log('【iAeonGetMemberInfo】favorite_store[0].code：' + aaa.favorite_store[0].code);
// 		console.log('【iAeonGetMemberInfo】aeonpay_flg：' + aaa.aeonpay_flg);
// 		// alert('【iAeonGetMemberInfo】aeon_memberid：' + aaa.aeon_memberid);
// 		// alert('【iAeonGetMemberInfo】aeonpay_flg：' + aaa.aeonpay_flg);

// 		//AeonPay連携 0:未許可 1:許可
// 		if(aaa.aeonpay_flg === "1"){ //連携ON
// 			updateAeonPayFlg("1");
// 		}else if(aaa.aeonpay_flg === "0"){ //連携OFF
// 			updateAeonPayFlg("0");
// 		}else { //未連携
// 			updateAeonPayFlg("undefined");
// 		}
// 		// updateTerminalCode(tcode);
// 		//18.データ保存API（端末番号保存
// 		// callAPI_18(tcode);
// 		//11.アプリケーション情報取得API
// 		// callAPI_11(tcode);
//     }
//     let errorCall_2 = function(error){
// 		// alert("【iAeonGetMemberInfo】error: " + error);
//         // var bbb = JSON.stringify(error);
// 		var bbb = error;
// 		console.log('【iAeonGetMemberInfo】error: ' + error.error_code + " : " + error.message);
// 		props.setErrFlg(true);
// 		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
// 		props.setErr([true, error.error_code, error_msg]);
//     }
// 	console.log("----------------------------");
// 	console.log("【iAeonGetMemberInfo】call");
//     iAeonGetMemberInfo().then(successCall_2).catch(errorCall_2);
// }

//お支払いモーダル表示時に、会員情報取得
// useEffect(() => {
// 	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
// 	if(process.env.REACT_APP_IAEON_FLG === "true"){
// 		console.log("iAEON 有効");
// 		if(props.showPayModal === true){
// 			//AEON Pay連携バージョン確認：5.1.0より小さい 連携なし（暫定版）、5.1.0以上 連携可能（連携版）
// 			if(sharedInfo.aeonPayVerCheck === true){ //5.1.0以上 連携可能（連携版）
// 				//2.会員情報取得API
// 				callAPI_2(sharedInfo.terminalCode);
// 			}
// 		}
// 	}
// }, [props.showPayModal]);


//----------------------------------------
//Zxing用QRスキャン
//----------------------------------------

// Zxing用 ---------------------------------------

const [QRcode, setQRcode] = useState('');

const { exitGateQR, updateExitGateQR } = useContext(SharedInfoContext);
const { signNumber, updateSignNumber } = useContext(SharedInfoContext);
const { registerNumber, updateRegisterNumber } = useContext(SharedInfoContext);
const { frontGateQR, updateFrontGateQR } = useContext(SharedInfoContext);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);

const { saleslistAPI, data: saleslistData, loading: saleslistLoading, error: saleslistError } = useUserAPI();
const { payreserveAPI, data: payreserveData, loading: payreserveLoading, error: payreserveError } = useUserAPI();
const { payAPI, data: payData, loading: payLoading, error: payError } = useUserAPI();


useEffect(() => {
	// console.log("useEffect purchaseData");
	if(saleslistData){
		if (saleslistData.data) { //SUCCESS

			// se07_scan();

			console.log(`【saleslistAPI】 sumIncludeTaxPrice: ${saleslistData.data.sumIncludeTaxPrice}`);
			console.log(`【saleslistAPI】 sumSellPrice: ${saleslistData.data.sumSellPrice}`);
			console.log(`【saleslistAPI】 sumItemCount: ${saleslistData.data.sumItemCount}`);

			console.log("QRコード判定（先頭2桁）: " + QRcode.substring(0, 2));
			if(QRcode.substring(0, 2) === "79"){ //代表レジ
				console.log("代表レジ");
				console.log(`【payreserveAPI】 registerNumber: ${QRcode}`);
				payreserveAPI(QRcode,props.otb);
			}else{ //専用レジ（個別レジ）・有人レジ
				console.log("専用レジ（個別レジ）・有人レジ");
				// const QRcode = "770000082900008730000009";
				// 15、16、17番目の文字を抽出
				const reginum = QRcode.substring(14, 17);
				console.log(`【payAPI】 registerNumber: ${reginum}`);
				updateRegisterNumber(reginum);
				payAPI(QRcode,props.otb);
			}
		}else{ //ERROR
			console.log(`【saleslistAPI】 errorCode: ${saleslistData.errorCode}`);
			console.log(`【saleslistAPI】 errorMessage: ${saleslistData.errorMessage}`);
			console.log(`【saleslistAPI】 isSuccess: ${saleslistData.isSuccess}`);

			if(saleslistData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${saleslistData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(saleslistData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${saleslistData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else if(saleslistData.errorCode === "32"){//フロントチェックエラー
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`,`${saleslistData.errorMessage}`]);
			}else{
				// props.setErrNum(`${saleslistData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${saleslistData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`,`${saleslistData.errorMessage}`]);

			}
		}
	}
	if(saleslistError){
		console.log("saleslistError");
		console.log(saleslistError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
}, [saleslistData,saleslistLoading,saleslistError]);


useEffect(() => {
	// console.log("useEffect purchaseData");
	if(payreserveData){
		if (payreserveData.data) { //SUCCESS
			console.log(`【payreserveAPI】 qrcode: ${payreserveData.data.qrcode}`);
			console.log(`【payreserveAPI】 signNumber: ${payreserveData.data.signNumber}`);
			console.log(`【payreserveAPI】 registerNumber: ${payreserveData.data.registerNumber}`);

			if(payreserveData.data.qrcode === "999"){ //有人レジ
				console.log("有人レジへ");
				goRegiYujin();
			}else if(payreserveData.data.qrcode === null){ //代表レジ 待ちなし精算確認APIへ
				console.log("代表レジ 待ちなし算確認APIへ");
				goRegiSenyou();
			}else{ //代表レジ 待ちあり精算確認APIへ
				console.log("代表レジ 待ちあり精算確認APIへ");
				goRegiSenyou();
			}
			updateExitGateQR(payreserveData.data.qrcode);
			updateSignNumber(payreserveData.data.signNumber);
			updateRegisterNumber(payreserveData.data.registerNumber);

		}else{ //ERROR
			console.log(`【payreserveAPI】 errorCode: ${payreserveData.errorCode}`);
			console.log(`【payreserveAPI】 errorMessage: ${payreserveData.errorMessage}`);
			console.log(`【payreserveAPI】 isSuccess: ${payreserveData.isSuccess}`);

			if(payreserveData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payreserveData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payreserveData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${payreserveData.errorCode}`,`${payreserveData.errorMessage}`]);
				console.log("エラー32：フロントチェックエラー");
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${payreserveData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${payreserveData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`,`${payreserveData.errorMessage}`]);

			}
		}
	}
	if(payreserveError){
		console.log("payreserveError");
		console.log(payreserveError);
		// エラーが発生した場合はボタンを再度有効化
		props.setIsButtonDisabled(false);
		// props.setErrFlg(true);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// if(payreserveError.errorCode === "35"){
		console.log("タイムアウト（ノーレスポンス）・通信エラーのため、精算確認APIへ自動遷移");
		props.setTimeoutCountFlg(true);
		props.setPage("regi_self");
		// }
	}
}, [payreserveData,payreserveLoading,payreserveError]);


useEffect(() => {
	// console.log("useEffect purchaseData");
	if(payData){
		if (payData.data) { //SUCCESS

			console.log(`【payAPI】 qrcode: ${payData.data.qrcode}`);

			if(payData.data.qrcode === "999"){ //有人レジ
				console.log("有人レジへ");
				goRegiYujin();
			}else if(payData.data.qrcode === null){ //専用レジ（個別レジ）待ちなし精算確認APIへ
				console.log("専用レジ（個別レジ）待ちなし算確認APIへ");
				goRegiSelf();
			}else{ //専用レジ（個別レジ）待ちあり精算確認APIへ
				console.log("専用レジ（個別レジ）待ちあり精算確認APIへ");
				goRegiSelf();
			}
			updateExitGateQR(payData.data.qrcode);
			// setScanItem(true);

		}else{ //ERROR
			console.log(`【payAPI】 errorCode: ${payData.errorCode}`);
			console.log(`【payAPI】 errorMessage: ${payData.errorMessage}`);
			console.log(`【payAPI】 isSuccess: ${payData.isSuccess}`);

			// エラーが発生した場合はボタンを再度有効化
			props.setIsButtonDisabled(false);

			if(payData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${payData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${payData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${payData.errorCode}`,`${payData.errorMessage}`]);
				console.log("エラー32：フロントチェックエラー");
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${payData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${payData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`,`${payData.errorMessage}`]);
			}
		}
	}
	if(payError){
		console.log("payError");
		console.log(payError);
		// エラーが発生した場合はボタンを再度有効化
		props.setIsButtonDisabled(false);
		// props.setErrFlg(true);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// if(payError.errorCode === "35"){
		console.log("タイムアウト（ノーレスポンス）・通信エラーのため、精算確認APIへ自動遷移");
		props.setTimeoutCountFlg(true);
		props.setPage("regi_self");
		// }
	}
}, [payData,payLoading,payError]);

const goRegiSenyou = () => {
	props.setPage("regi_senyou")
}
const goRegiSelf = () => {
	props.setPage("regi_self")
}
const goRegiYujin = () => {
	props.setPage("regi_yujin")
}

// Zxing用 ---------------------------------------



//----------------------------------------
//QRスキャン遷移（Zxing以外
//----------------------------------------

const goQRScan = () => {
	console.log("REACT_APP_ZXING: " + process.env.REACT_APP_ZXING);
	if(process.env.REACT_APP_ZXING === "true"){ //ZXING QR有効
		console.log("ZXING QR有効");
		props.setShowPayModal(false);
		// let zxing_result = zxingScan(123);
		// console.log("zxing_result: " + zxing_result);
		zxingQRScan().then(data => {
			console.log("zxing_qr_result: " + data);
			// se07_scan();
			props.setSoundState("se07_scan");

			setQRcode(data);
			updateFrontGateQR(data);
			updateRegisterNumber(data);
			saleslistAPI();

		}).catch(error => {
			console.log("【iAeonDoCodeRead】error: ", error);
			console.log('【iAeonDoCodeRead】error: ' + error.error_code + " : " + error.message);
			// props.setSoundState("se07_scan");
			// props.setErrFlg(true);
			// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
			// props.setErr([true, error.error_code, error_msg]);
			// props.setErr([true, process.env.REACT_APP_ERROR_CODE_000018, process.env.REACT_APP_ERROR_MESSAGE_000018]);
			// props.setErr([true,`000018`,`;バーコード・QRコード読み取り失敗;;;;`]);
		});
		// props.se08_se();
		props.setSoundState("se08_se");

	}else{ //ZXING QR無効 → scandit QR有効
		console.log("scandit QR有効");
		//「お会計」ボタンを無効化
		props.setIsKaikeiButtonDisabled(true);
		// (async () => {
		// 	// await sdk.enableScanning(true);
		// 	await sdk.enableCamera(true);
		// })();
		props.setShowPayModal(false);
		setTimeout(function(){
			document.getElementById('header').classList.add('is_behind');
			props.setTimeoutCountFlg(false);
			props.setTimeoutCount(0);
			props.setPage("qrscan");
			// props.setScanActive("qrcode");
		}, 100);
		// }, 2000);
	}
}


// モーダルUIは表示しない（バックグラウンド処理専用コンポーネント）
return null;

}
